import log from 'loglevel';
import { ConfigurationManager } from '../configuration-manager/configuration-manager';
import { OnsiteDisplayData } from '../integrations/onsite-display/onsite-display.model';
import { BrowserNotificationData } from '../integrations/browser-notification/browser-notification.model';
import { ExitIntentData } from '../integrations/exit-intent/exit-intent.model';


export interface DefaultResponseBody {
  xngGlobalUserId: string;
  xngSessionId: string;
  onsiteEnabled: boolean;
  exitIntentEnabled: boolean;
  browserNotificationEnabled: boolean;
  onsiteDisplays?: OnsiteDisplayData[];
  notifications?: BrowserNotificationData[];
  exitIntendMessages?: ExitIntentData[];
}

/**
 * Handles the formatting and processing of http requests.
 */
export class RequestManager {

  private static response$: Function[] = [];
  private static request$: Function[] = [];

  static request<T>(endpointUrl: string, method: string, body: any): Promise<T | void> {
    const url = `${ConfigurationManager.get('apiUrl')}/${ConfigurationManager.get('apiKey')}/${endpointUrl}`;

    if (!ConfigurationManager.get('trackingOptIn')) {
      window.ceDebugger?.pushRequest(url, body, null);
      log.debug(`xhr: request to ${url} blocked due to tracking opt out.`);
      return Promise.resolve();
    }

    // Note: fetch is not supported by IE. Consider Polyfill. (check if included in polyfill package)
    return fetch(url, {
      method: method,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify(body)
    })
    .then(response => {
      window.ceDebugger && response.clone().json().then(responseBody => {
        window.ceDebugger?.pushRequest(url, body, responseBody);
      });
      return response;
    })
    .then(this.handleResponseError)
    .then(response => response.json())
    .then((data: T) => {
      log.debug(`xhr:${method} at '/${endpointUrl}' response body: `, data);
      this.request$.forEach(subscription => subscription(body));
      this.response$.forEach(subscription => subscription(data));
      return data;
    }).catch(error => {
      log.error(`xhr:${method} at '/${endpointUrl}' request failed: `, error);
    });
  }

  /**
   * Allows to subscribe to successful http requests.
   * @param fn Callback function that takes the request body as argument.
   */
  static subscribeToRequest(fn: (requestBody: any) => void): void {
    this.request$.push(fn);
  }

    /**
   * Allows to subscribe to successful http requests.
   * @param fn Callback function that takes the response body as argument.
   */
  static subscribeToResponse(fn: (responseBody: DefaultResponseBody) => void): void {
    this.response$.push(fn);
  } 


  

  private static handleResponseError(response: Response) {
    if (!response.ok) {
      throw Error(`${response.status}`);
    }
    return response;
  }
}
